import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  GetTaskTypes,
  SetBusinessDays,
  validationSchema,
  checkIfUserIsOwner,
  markProjectMembership,
} from "../helpers/task-helpers";
import { LoginContext } from "../../../../../services/api/authentication-api";
import TaskDetailsSection from "../common-components/task-details-section";
import { Button, Form, Modal } from "react-bootstrap";
import { Formik } from "formik";
import DynamicTaskDetails from "../common-components/dynamic-task-details";
import TaskAssignMemberWrapper from "../../../../../components/TaskAssignMemberWrapper/TaskAssignMemberWrapper";
import TaskAssignMemberMultiOwnerWrapper from "../../../../../components/TaskAssignMemberWrapper/TaskAssignMemberMultiOwnerWrapper";
import TaskCreateEditComments from "../common-components/task-create-edit-comments";
import { ToBase64 } from "../../../../../util/file-helpers";
import {
  EditStandardTaskWeb,
  GetFormSubmission,
  GetTaskWorflowButtonsWithAssignedPermissions,
  SetWorkItemInProgressAPI
} from "../../../../../services/api/task-api";
import { TaskStatusTypes } from "../../tasks-actions-panel/task-status-types";
import { isDynamicFieldsValid } from "../../../../../components/DynamicField/Tasks/utils/utils";
import TasksCommentsNew from "../common-components/tasks-comments-new";
import TaskEditTop from "./task-edit-top";
import TaskEditBottom from "./task-edit-bottom";
import { PulseLoader } from "react-spinners";
import PropTypes from "prop-types";
import TaskFormTable from "./task-form-table";
import { Helmet } from "react-helmet-async";
import TaskForm from "../../task-form/task-form";
import { FluentProvider, webLightTheme } from "@fluentui/react-components";
import MemberIconNew from "../../../../../components/member-icon-new/member-icon-new";
import { NIL as NIL_UUID } from "uuid";
import TaskEditHeader from "./task-edit-header";
import { GetUserProjectsForTaskCreateEdit } from "../../../../../services/api/project-api";
import { AddMembersAndGroupsToProject } from "../../../../../services/api/user-api";
import NoTaskAccess from "../../../../errors/scenes/ForbiddenPage/no-task-access";

const TaskEdit = (props) => {
  const user = useContext(LoginContext);
  const labels = user?.currentUser?.objectLabels;
  const location = useLocation();

  const [standardTask, setStandardTask] = useState({});
  const [activeProjects, setActiveProjects] = useState([]);
  const [workItemTypes, setWorkItemTypes] = useState([]);
  const [workItemType, setWorkItemType] = useState();
  const [loaded, setLoaded] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [newCommentText, setNewCommentText] = useState("");
  const [dynamicFields, setDynamicFields] = useState([]);
  const [dynamicCommentField, setCommentDynamicFields] = useState([]);
  const [taskMembers, setTaskMembers] = useState([]);
  const [taskOtherMembers, setTaskOtherMembers] = useState([]);
  const [selectedMembersEdit, setSelectedMembersEdit] = useState([]);
  const [selectedMembersView, setSelectedMembersView] = useState([]);
  const [selectedMembersApprove, setSelectedMembersApprove] = useState([]);
  const [selectedMembersOwner, setSelectedMembersOwner] = useState([]);
  const [selectedGroupEdit, setSelectedGroupEdit] = useState([]);
  const [selectedGroupView, setSelectedGroupView] = useState([]);
  const [selectedGroupApprove, setSelectedGroupApprove] = useState([]);
  const [selectedGroupsOwner, setSelectedGroupsOwner] = useState([]);
  const [groupOwner, setGroupOwner] = useState(null);
  const [disableFields, setDisableFields] = useState(true);
  const [showFormModal, setShowFormModal] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });
  const [panelVisibility, setPanelVisibility] = useState({
    showCreatedModal: false,
    showActionsPanel: 0,
  });
  const [tags, setTags] = useState([]);
  const [refreshCommentsTable, setRefreshCommentsTable] = useState(0);
  const [forms, setForms] = useState([]);
  const [taskName, setTaskName] = useState(standardTask?.Name ?? "");
  const [refreshStatus, setRefreshStatus] = useState(false);
  const taskDetailsRef = useRef(null);
  const taskFormAssignMembersRef = useRef(null);
  const auditTrailRef = useRef(null);
  const actionsRef = useRef(null);
  const [noAccess, setNoAccess] = useState(false);
  const [projectIsMultiOwner, setProjectIsMultiOwner] = useState(false);
  const IsMultiOwner = projectIsMultiOwner;
  const [dynamicFormStatus, setDynamicFormStatus] = useState(false);
  
  useEffect(() => {
    SetBusinessDays();
    let id = location.pathname.split("/")[4] || props.id;
    GetProjects();
    GetTask(id);
    GetTaskTypes(setWorkItemTypes);
  }, []);

  useEffect(() => {
    if (standardTask != null && standardTask?.WorkItemTypeId != null) {
      let workItemType = workItemTypes.find(
        (item) => item.Id == standardTask.WorkItemTypeId
      );
      setWorkItemType(workItemType);
    }
  }, [workItemTypes, standardTask]);

  const getWorkflowButtons = async (Id) => {
    let result = await GetTaskWorflowButtonsWithAssignedPermissions(Id);
    let data = result?.data;
    if (result?.status === 200) {
      data.selectedProject = data.Project;
      data.Start = new Date(data.Start);
      data.Due = new Date(data.Due);
      InitializeGroupOwner(data);
    }

    return data;
  };

  const InitializeGroupOwner = (task) => {
    let temp = task?.Groups?.filter((group) => {
      if (group.IsOwner) {
        return group;
      }
    });
    if (temp?.length > 0) {
      setGroupOwner(temp[0]);
    }
  };

  const GetProjects = async () => {   
    const response = await GetUserProjectsForTaskCreateEdit();
    if (response.status === 200) {
      const projects = response.data;
      setActiveProjects(projects);      
    } else {
      setAlertConfig((prev) => ({
        showAlert: true,
        alertAction: "Cannot get projects",
        alertMessage: response?.message?.toString(),
        alertVariant: "danger",
      }));
    }    
  };

  const GetTask = async (id) => {
    SetWorkItemInProgressAPI(parseInt(id));
    let path = location.pathname.split("/");
    let isView = path.includes("view");
    setLoaded(false);
    let result = await getWorkflowButtons(id);
    if(result.AssignedMemberPermission.IsTaskMember ===false){
      setLoaded(true);
      setNoAccess(true);      
      return;
    }

    if (result.ProjectId !== 0) {
      let groups = result.Groups.map((group) => {
        group.Id = group.GroupId;
        group.UserId = group.GroupId;
        group.User = {
          Id: group.GroupId,
        };
        group.IsGroup = true;
        return group;
      });
      result.Members = [...result.Members, ...groups];
      setTaskMembers(result.Members);
      setDynamicFormStatus(result.IsFormStatus);
      markProjectMembership(result.Project);

      let DepMem = result?.Project?.DepMembers?.filter(
        (user) => !result.Project.Members.some((member) => member?.User?.Id === user.Id)
      ).map((user) => {
        user.User = { ...user };
        return user;
      });

      let DepGroups = result?.Project?.DepGroups?.filter(
        (group) => !result.Project.Groups.some((member) => group.Id === member.GroupId)
      ).map((group) => {
        group.IsGroup = true;
        group.User = { ...group };
        return group;
      });

      setTaskOtherMembers([...result?.Project?.Members || [], ...result?.Project?.Groups || [], ...DepMem || [], ...DepGroups || []]);
      setProjectIsMultiOwner(result?.IsMultiOwner ?? false);
      setStandardTask(result);
      setTaskName(result?.Name ?? "");
      const isOwner = checkIfUserIsOwner(result, user.userID, IsMultiOwner);
      let isdisabled =
        result?.StatusId === 2 ||
        result?.StatusId === 3 ||
        result?.StatusId === 8 ||
        result?.isArchived === true ||
        (result?.Permission === "View" && !isOwner);

      setDisableFields(isdisabled || isView);
      setSelectedMembersEdit(
        result?.Members?.filter(
          (member) => (member.CanEdit || member.IsAssigned) && !member.IsGroup
        )?.map((member) => member.UserId)
      );
      setSelectedMembersApprove(
        result?.Members?.filter(
          (member) => member.CanApprove && !member.IsGroup
        )?.map((member) => member.UserId)
      );
      setSelectedMembersView(
        result?.Members?.filter(
          (member) => member.CanView && !member.IsGroup
        )?.map((member) => member.UserId)
      );
      setSelectedGroupEdit(
        result?.Members?.filter(
          (member) => (member.CanEdit || member.IsAssigned) && member.IsGroup
        )?.map((member) => member.UserId)
      );
      setSelectedGroupApprove(
        result?.Members?.filter(
          (member) => member.CanApprove && member.IsGroup
        )?.map((member) => member.UserId)
      );
      setSelectedGroupView(
        result?.Members?.filter(
          (member) => member.CanView && member.IsGroup
        )?.map((member) => member.UserId)
      );
      //For multiple owners
      setSelectedMembersOwner(
        result?.Members?.filter(
          (member) => member.IsOwner && !member.IsGroup
        )?.map((member) => member.UserId)
      );
      const owners = result?.Members?.filter((member) => member.IsOwner && !member.IsGroup);
      setSelectedGroupsOwner(
        result?.Members?.filter(
          (member) => member.IsOwner && member.IsGroup
        )?.map((member) => member.UserId)
      );
      setLoaded(true);
    } else {
      setStandardTask(result);
      setLoaded(true);
    }
  };

  const onSubmit = async (values, actions) => {
    await editStandardTask(values, actions, false);
  };

  const memberPermissionValidation = () => {
    if (selectedMembersEdit.length > 0) {
      return true;
    }

    const ownerMissingOtherPermissions = selectedMembersOwner.some(ownerId =>
      !selectedMembersView.includes(ownerId) &&
      !selectedMembersApprove.includes(ownerId)
    );
    if (ownerMissingOtherPermissions) {
      return true;
    }

    setAlertConfig(prev => ({
      ...prev,
      showAlert: true,
      alertAction: "Please assign at least one member as an editor",
      alertMessage: "",
      alertVariant: "danger",
    }));
    return false;
  };

  const editStandardTask = async (values, actions, isUseCase3Ready) => {

    let tzoffset = new Date(values.Start).getTimezoneOffset() * 60000;
    let tzendoffset = new Date(values.Due).getTimezoneOffset() * 60000;
    let startDate = new Date(values.Start - tzoffset);
    let endDate = new Date(values.Due - tzendoffset);

    values = { ...values, Start: startDate };
    values = { ...values, Due: endDate };

    startDate = startDate.toISOString();
    endDate = endDate.toISOString();
    startDate = startDate.split("T")[0];
    endDate = endDate.split("T")[0];
    let projStartDate = values.selectedProject?.Start;
    let projEndDate = values.selectedProject?.End;
    projStartDate = projStartDate?.split("T")[0];
    projEndDate = projEndDate?.split("T")[0];

    if (startDate > endDate) {
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Start date is greater than due date",
        alertMessage: "",
        alertVariant: "danger",
      }));
      actions.setSubmitting(false);
      return {};
    }

    if (
      startDate < projStartDate ||
      startDate > projEndDate ||
      endDate > projEndDate ||
      endDate < projStartDate
    ) {
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction:
          "Invalid start/due dates, please compare to project start/due dates before submitting",
        alertMessage: "",
        alertVariant: "danger",
      }));
      actions.setSubmitting(false); //Set submitting to false at end of cycle
      return {};
    }

    if (!memberPermissionValidation()) {
      actions.setSubmitting(false);
      return;
    }

    const convertedFiles = await Promise.all(
      selectedFiles.map(async (file) => {
        const result = await ToBase64(file);
        let mimetype = result.substr(
          result.indexOf(":") + 1,
          result.indexOf(";") - result.indexOf(":") - 1
        );
        let thedocAsBytes = result.split(",")[1];
        return {
          FileName: file.name,
          FileContentType: mimetype,
          FileByteArray: thedocAsBytes,
        };
      })
    );
    let obj = {
      Id: values.Id,
      ProjectId: values.ProjectId,
      Name: values.Name,
      WorkItemTypeId: values.workItemType,
      Priority: parseInt(values.PriorityId),
      Start: values.Start,
      Due: values.Due,
      SelectedMembersView: selectedMembersView,
      SelectedMembersEdit: selectedMembersEdit,
      SelectedMembersApprove: selectedMembersApprove,
      SelectedGroupEdit: selectedGroupEdit,
      SelectedGroupView: selectedGroupView,
      SelectedGroupApprove: selectedGroupApprove,
      SelectedMembersOwner: selectedMembersOwner,
      SelectedGroupsOwner: selectedGroupsOwner,
      dynamicFields: dynamicFields?.map((field) => ({
        DynamicFieldId: field.Id,
        Data: field.Data,
        Table: field.Table,
        ObjectId: values.Id,
        Files: field.Files,
      })),
      dynamicFieldsComments: dynamicCommentField.map((field) => ({
        DynamicFieldId: field.Id,
        Data: field.Data,
        ObjectId: 0,
      })),
      taskCommentFiles: convertedFiles,
      CommentText: newCommentText,
      StatusId: isUseCase3Ready
        ? TaskStatusTypes.APPROVED
        : TaskStatusTypes.ASSIGNED,
      CreatedById: selectedMembersOwner[0],
    };
    setLoaded(false);

    let response = await EditStandardTaskWeb(obj);

    if (response.status === 200) {
      let assignedUsers = [...selectedMembersEdit, ...selectedMembersView, ...selectedMembersApprove, ...selectedMembersOwner];
      let assignedGroups = [...selectedGroupEdit, ...selectedGroupView, ...selectedGroupApprove, ...selectedGroupsOwner];
      let usersToBeAdded = assignedUsers.filter((user) => !values.selectedProject.Members.some((member) => member.UserId === user));
      let groupsToBeAdded = assignedGroups.filter((group) => !values.selectedProject.Groups.some((member) => member.UserId === group));
      if (usersToBeAdded.length > 0 || groupsToBeAdded.length > 0) {
        let obj ={
          UserIds : usersToBeAdded,
          GroupIds : groupsToBeAdded,
          ProjectId : values.selectedProject.Id
        }
        AddMembersAndGroupsToProject(obj)
      }

      setPanelVisibility((prev) => ({ ...prev, showCreatedModal: true }));
      setLoaded(true);
    } else {
      setAlertConfig((prev) => ({
        ...prev,
        showAlert: true,
        alertAction: "Error creating task",
        alertMessage: response?.response?.data,
        alertVariant: "danger",
      }));
      setLoaded(true);
    }
  };

  const onValidation = (dynamicFields, setDynamicFields) => {
    const errors = {};
    if (!isDynamicFieldsValid(dynamicFields)) {
      setDynamicFields(
        dynamicFields.map((field) => ({ ...field, touched: true }))
      );
      errors.dynamicFields = "Dynamic Fields are Invalid";
    }
    return errors;
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };

  const setFormModal = async (value) => {
    let result = await GetFormSubmission(value.Comment.Id, standardTask.Id);
    if (result?.status === 200) {
      value.formdata = result.data;
      setSelectedForm(value);
      setShowFormModal(true);
    }
  };

  const scrollToSection = (ref) => {
    if (ref.current) {
      const headerOffset = 113; // TaskEditHeader height
      const elementPosition = ref.current.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
  
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="task-create">
      <Helmet>
        <title>TRIYO · Edit {labels?.TaskSingular ?? 'Task'}</title>
      </Helmet>
      {!loaded ? (
        <div className="loading-overlay ">
          <div className="loading-spinner-wrapper">
            <PulseLoader className="loading-spinner"></PulseLoader>
          </div>
        </div>
      )
      : noAccess ? (
        <NoTaskAccess></NoTaskAccess> )
      : (

        <div className="task-create-standard-panel">
        <TaskEditHeader 
          task={standardTask} 
          taskName={taskName} 
          refreshStatus={refreshStatus} 
          setRefreshStatus={setRefreshStatus} 
          GetTask={GetTask} 
          scrollToSection={scrollToSection}
          isView={disableFields}
          labels={labels}
          refs={{
            taskDetailsRef,
            taskFormAssignMembersRef,
            auditTrailRef,
            actionsRef,
          }}/>
          <TaskEditTop
            standardTask={standardTask}
            panelVisibility={panelVisibility}
            setPanelVisibility={setPanelVisibility}
            alertConfig={alertConfig}
            setAlertConfig={setAlertConfig}
            labels={labels}
          />
          <div className="task-edit-standard-panel">
            <div className="edit-container">
              <Formik
                validationSchema={validationSchema(labels)}
                initialValues={standardTask}
                onSubmit={async (values, actions) =>
                  await onSubmit(values, actions)
                }
                validate={async () =>
                  await onValidation(dynamicFields, setDynamicFields)
                }
              >
                {({
                  handleSubmit,
                  handleChange,
                  values,
                  touched,
                  errors,
                  setFieldValue,
                  isSubmitting,
                  submitForm,
                  actions,
                }) => (
                  <Form
                    onSubmit={handleSubmit}
                    noValidate
                    className="create-container"
                    onKeyDown={onKeyDown}
                  >
                    <div className="form-container">
                      <div className="task-top-section" >
                        <h4 className="heading" ref={taskDetailsRef}>{labels?.TaskSingular ?? 'Task'} Detail</h4>
                        <TaskDetailsSection
                          values={values}
                          touched={touched}
                          errors={errors}
                          handleChange={handleChange}
                          setFieldValue={setFieldValue}
                          workItemTypes={workItemTypes}
                          activeProjects={activeProjects}
                          dateFormatID={props.dateFormatID}
                          setTaskOtherMembers={setTaskOtherMembers}
                          disabled={disableFields}
                          setWorkItemType={setWorkItemType}
                          borderBottom={dynamicFields?.length === 0}
                          setTaskName={setTaskName}
                          labels={labels}
                          onProjectSelected={(isMultiOwner) => {
                            setProjectIsMultiOwner(isMultiOwner ?? false);
                          }}
                        />
                        <DynamicTaskDetails
                          standardTask={standardTask}
                          values={values}
                          touched={touched}
                          dynamicFields={dynamicFields}
                          setDynamicFields={setDynamicFields}
                          disabled={disableFields}
                        />
                        <div className="task-row-wrapper" ref={taskFormAssignMembersRef}>
                          <div className="taskForm" >
                            <TaskFormTable
                              forms={forms}
                              setForms={setForms}
                              taskId={standardTask.Id}
                              values={values}
                              dynamicFormStatus={dynamicFormStatus}
                              labels={labels}
                              disabled={disableFields}
                            />
                          </div>
                          {IsMultiOwner ? (
                            <TaskAssignMemberMultiOwnerWrapper
                              isCreate={false}
                              task={standardTask}
                              taskMembers={taskMembers}
                              setTaskMembers={setTaskMembers}
                              projectMembers={taskOtherMembers}
                              selectedMembersEdit={selectedMembersEdit}
                              setSelectedMembersEdit={setSelectedMembersEdit}
                              selectedMembersView={selectedMembersView}
                              setSelectedMembersView={setSelectedMembersView}
                              selectedMembersApprove={selectedMembersApprove}
                              setSelectedMembersApprove={setSelectedMembersApprove}
                              selectedGroupEdit={selectedGroupEdit}
                              setSelectedGroupEdit={setSelectedGroupEdit}
                              selectedGroupView={selectedGroupView}
                              setSelectedGroupView={setSelectedGroupView}
                              selectedGroupApprove={selectedGroupApprove}
                              setSelectedGroupApprove={setSelectedGroupApprove}
                              selectedMembersOwner={selectedMembersOwner}
                              setSelectedMembersOwner={setSelectedMembersOwner}
                              selectedGroupsOwner={selectedGroupsOwner}
                              setSelectedGroupsOwner={setSelectedGroupsOwner}
                              workItemType={workItemType}
                              groupOwner={groupOwner}
                              disabled={disableFields}
                            />
                          ) : (
                            <TaskAssignMemberWrapper
                              isCreate={false}
                              task={standardTask}
                              taskMembers={taskMembers}
                              setTaskMembers={setTaskMembers}
                              projectMembers={taskOtherMembers}
                              selectedMembersEdit={selectedMembersEdit}
                              setSelectedMembersEdit={setSelectedMembersEdit}
                              selectedMembersView={selectedMembersView}
                              setSelectedMembersView={setSelectedMembersView}
                              selectedMembersApprove={selectedMembersApprove}
                              setSelectedMembersApprove={setSelectedMembersApprove}
                              selectedGroupEdit={selectedGroupEdit}
                              setSelectedGroupEdit={setSelectedGroupEdit}
                              selectedGroupView={selectedGroupView}
                              setSelectedGroupView={setSelectedGroupView}
                              selectedGroupApprove={selectedGroupApprove}
                              setSelectedGroupApprove={setSelectedGroupApprove}
                              selectedMembersOwner={selectedMembersOwner}
                              setSelectedMembersOwner={setSelectedMembersOwner}
                              selectedGroupsOwner={selectedGroupsOwner}
                              setSelectedGroupsOwner={setSelectedGroupsOwner}
                              workItemType={workItemType}
                              groupOwner={groupOwner}
                              disabled={disableFields}
                            />
                          )}
                          <TasksCommentsNew
                            assignID={standardTask.Id}
                            type="standard"
                            dateFormatID={props.dateFormatID}
                            taskMembers={taskMembers}
                            workItem={{
                              ...values,
                              projectTypeID: values.TemplateTaskId,
                            }}
                            disabled={disableFields}
                            setTags={setTags}
                            setAlertConfig={setAlertConfig}
                            alertConfig={alertConfig}
                            refreshCommentsTable={refreshCommentsTable}
                            setFormModal={setFormModal}
                            labels={labels}
                          />
                          <div className="taskForm" ref={auditTrailRef}>
                            <TaskCreateEditComments
                              projectTypeId={standardTask.ProjectTypeId}
                              taskTypeId={values.workItemType}
                              dynamicFields={dynamicCommentField}
                              setDynamicFields={setCommentDynamicFields}
                              touched={touched}
                              taskMembers={taskMembers}
                              newCommentText={newCommentText}
                              setNewCommentText={setNewCommentText}
                              allUsers={taskOtherMembers?.map(
                                (member) => member.User.Name
                              )}
                              selectedFiles={selectedFiles}
                              setSelectedFiles={setSelectedFiles}
                              assignID={standardTask.Id}
                              type="standard"
                              workItem={{
                                ...values,
                                projectTypeID: values.TemplateTaskId,
                              }}
                              disabled={disableFields}
                              tags={tags}
                              setAlertConfig={setAlertConfig}
                              alertConfig={alertConfig}
                              setRefreshCommentsTable={setRefreshCommentsTable}
                              setRefreshStatus={setRefreshStatus}
                            />
                          </div>
                          <div ref={actionsRef}>
                            <TaskEditBottom
                              standardTask={standardTask}
                              setPanelVisibility={setPanelVisibility}
                              disableFields={disableFields}
                              isSubmitting={isSubmitting}
                              labels={labels}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          {showFormModal && (
            <Modal
              show={showFormModal}
              onHide={() => setShowFormModal(false)}
              contentClassName="formModal"
            >
              <Modal.Header>
                <div>
                  <Modal.Title className="modal-title">
                    {selectedForm?.formdata?.Label}
                  </Modal.Title>
                  <div className="form-subtitle">
                    <MemberIconNew
                      member={selectedForm?.CreatedBy}
                    ></MemberIconNew>
                    <span>
                      <div>{selectedForm?.CreatedBy?.Name}</div>
                      <div>{selectedForm?.CreatedBy?.Email}</div>
                    </span>
                  </div>
                </div>
                <Button
                  className="close-document-viewer-btn btn-primary"
                  onClick={() => setShowFormModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body className="formModal">
                <FluentProvider theme={webLightTheme}>
                  {selectedForm?.formdata?.Id !== NIL_UUID ? (
                    <TaskForm
                      FormData={selectedForm?.formdata}
                      IsView={true}
                    ></TaskForm>
                  ) : (
                    <div>Submission not available</div>
                  )}
                </FluentProvider>
              </Modal.Body>
            </Modal>
          )}
        </div>

      )}
    </div>

  );
};

TaskEdit.propTypes = {
  dateFormatID: PropTypes.string,
};
export default TaskEdit;
